<template>
  <div>
    <div class="GeZai_Layer relative">
      <PanelImage @image_loaded="engravingElementsVisible = true;" @image_loading="engravingElementsVisible = false;" />

      <div class="body-img" :class="$store.getters.hOrV">
        <div class="table2" :class="{
          two: $store.state.artwork.format == 'double',
          vtwo: $store.state.artwork.format == 'vdouble',
          three: $store.state.artwork.format == 'triple',
          vthree: $store.state.artwork.format == 'vtriple',
        }">
          <engraving-elements :elements="layer4" :fontType="$store.state.artwork.fontType"
            v-if="engravingElementsVisible" />
          <engraving-elements :elements="rightLayer4" :fontType="$store.state.artwork.fontType"
            v-if="$store.state.artwork.format != 'single' && engravingElementsVisible"/>
          <engraving-elements :elements="tripleRightLayer4" :fontType="$store.state.artwork.fontType"
            v-if="$store.getters.isTriple && engravingElementsVisible"  />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EngravingElements from "../../../components/EngravingElements.vue";
var albaButtonPositionsCombinations = {
  leftButton: {
    single: {
      A: {
        left: [
          { x: 14.4, y: 14.07 },
          { x: 14.4, y: 64.3 }
        ],
        right: [
          { x: 51.6, y: 14.07 },
          { x: 51.6, y: 64.3 },
        ]
      },
      B: {
        left: [
          { x: 14.4, y: 14.07 },
          { x: 14.4, y: 30.8 },
          { x: 14.4, y: 47.6 },
          { x: 14.4, y: 64.3 }
        ],
        right: [
          { x: 51.6, y: 14.07 },
          { x: 51.6, y: 30.8 },
          { x: 51.6, y: 47.6 },
          { x: 51.6, y: 64.3 },
        ]
      },
      D: {
        left: [
          { x: 14.4, y: 14.07 },
          { x: 14.4, y: 30.8 },
          { x: 14.4, y: 47.6 },
          { x: 14.4, y: 64.3 }
        ],
        right: [
          { x: 51.6, y: 14.07 },
          { x: 51.6, y: 30.8 },
          { x: 51.6, y: 47.6 },
          { x: 51.6, y: 64.3 },
        ]
      },
      M1: {
        left: [
          { x: 14.25, y: 47.1 },
          { x: 14.25, y: 64.3 },
          { x: 51.4, y: 47.1 },
          { x: 51.4, y: 64.3 },
        ]
      },
      SK: { left: [] },
    },
    double: {
      A: {
        left: [
          { x: 15.7, y: 14.07 },
          { x: 15.7, y: 64.3 }
        ],
        right: [
          { x: 52.9, y: 14.07 },
          { x: 52.9, y: 64.3 },
        ]
      },
      B: {
        left: [
          { x: 15.7, y: 14.07 },
          { x: 15.7, y: 30.8 },
          { x: 15.7, y: 47.6 },
          { x: 15.7, y: 64.3 }
        ],
        right: [
          { x: 52.9, y: 14.07 },
          { x: 52.9, y: 30.8 },
          { x: 52.9, y: 47.6 },
          { x: 52.9, y: 64.3 },
        ]
      },
      D: {
        left: [
          { x: 15.7, y: 14.07 },
          { x: 15.7, y: 30.8 },
          { x: 15.7, y: 47.6 },
          { x: 15.7, y: 64.3 }
        ],
        right: [
          { x: 52.9, y: 14.07 },
          { x: 52.9, y: 30.8 },
          { x: 52.9, y: 47.6 },
          { x: 52.9, y: 64.3 },
        ]
      },
      M1: {
        left: [
          { x: 15.5, y: 47.1 },
          { x: 15.5, y: 64.3 },
          { x: 52.7, y: 47.1 },
          { x: 52.7, y: 64.3 },
        ]
      },
      SK: { left: [] },
    },
    vdouble: {
      A: {
        left: [
          { x: 14.4, y: 15.4 },
          { x: 14.4, y: 65.7 }
        ],
        right: [
          { x: 51.6, y: 15.4 },
          { x: 51.6, y: 65.7 },
        ]
      },
      B: {
        left: [
          { x: 14.4, y: 15.4 },
          { x: 14.4, y: 32.2 },
          { x: 14.4, y: 48.8 },
          { x: 14.4, y: 65.7 }
        ],
        right: [
          { x: 51.6, y: 15.4 },
          { x: 51.6, y: 32.2 },
          { x: 51.6, y: 48.8 },
          { x: 51.6, y: 65.7 },
        ]
      },
      D: {
        left: [
          { x: 14.4, y: 15.4 },
          { x: 14.4, y: 32.2 },
          { x: 14.4, y: 48.8 },
          { x: 14.4, y: 65.7 }
        ],
        right: [
          { x: 51.6, y: 15.4 },
          { x: 51.6, y: 32.2 },
          { x: 51.6, y: 48.8 },
          { x: 51.6, y: 65.7 },
        ]
      },
      M1: {
        left: [
          { x: 14.25, y: 48.7 },
          { x: 14.25, y: 65.9 },
          { x: 51.4, y: 48.7 },
          { x: 51.4, y: 65.9 },
        ]
      },
      SK: { left: [] },
    },
    triple: {
      A: {
        left: [
          { x: 16.9, y: 14.07 },
          { x: 16.9, y: 64.3 }
        ],
        right: [
          { x: 54.1, y: 14.07 },
          { x: 54.1, y: 64.3 },
        ]
      },
      B: {
        left: [
          { x: 16.9, y: 14.07 },
          { x: 16.9, y: 30.8 },
          { x: 16.9, y: 47.6 },
          { x: 16.9, y: 64.3 }
        ],
        right: [
          { x: 54.1, y: 14.07 },
          { x: 54.1, y: 30.8 },
          { x: 54.1, y: 47.6 },
          { x: 54.1, y: 64.3 },
        ]
      },
      D: {
        left: [
          { x: 16.9, y: 14.07 },
          { x: 16.9, y: 30.8 },
          { x: 16.9, y: 47.6 },
          { x: 16.9, y: 64.3 }
        ],
        right: [
          { x: 54.1, y: 14.07 },
          { x: 54.1, y: 30.8 },
          { x: 54.1, y: 47.6 },
          { x: 54.1, y: 64.3 },
        ]
      },
      M1: {
        left: [
          { x: 16.7, y: 47.1 },
          { x: 16.7, y: 64.3 },
          { x: 54.2, y: 47.1 },
          { x: 54.2, y: 64.3 },
        ]
      },
      SK: { left: [] },
    },
    vtriple: {
      A: {
        left: [
          { x: 14.4, y: 16.6 },
          { x: 14.4, y: 66.8 },
        ],
        right: [
          { x: 51.6, y: 16.6 },
          { x: 51.6, y: 66.8 },
        ]
      },
      B: {
        left: [
          { x: 14.4, y: 16.6 },
          { x: 14.4, y: 33.3 },
          { x: 14.4, y: 50.1 },
          { x: 14.4, y: 66.8 },
        ],
        right: [
          { x: 51.6, y: 16.6 },
          { x: 51.6, y: 33.3 },
          { x: 51.6, y: 50.1 },
          { x: 51.6, y: 66.8 },
        ]
      },
      D: {
        left: [
          { x: 14.4, y: 16.6 },
          { x: 14.4, y: 33.3 },
          { x: 14.4, y: 50.1 },
          { x: 14.4, y: 66.8 },
        ],
        right: [
          { x: 51.6, y: 16.6 },
          { x: 51.6, y: 33.3 },
          { x: 51.6, y: 50.1 },
          { x: 51.6, y: 66.8 },
        ]
      },
      SK: { left: [] },
    }
  },
  rightButton: {
    double: {
      A: {
        left: [
          { x: 113.2, y: 14.07 },
          { x: 113.2, y: 64.3 },
        ],
        right: [
          { x: 150.4, y: 14.07 },
          { x: 150.4, y: 64.3 },
        ]
      },
      B: {
        left: [
          { x: 113.2, y: 14.07 },
          { x: 113.2, y: 30.8 },
          { x: 113.2, y: 47.6 },
          { x: 113.2, y: 64.3 },
        ],
        right: [
          { x: 150.4, y: 14.07 },
          { x: 150.4, y: 30.8 },
          { x: 150.4, y: 47.6 },
          { x: 150.4, y: 64.3 },
        ]
      },
      D: {
        left: [
          { x: 113.2, y: 14.07 },
          { x: 113.2, y: 30.8 },
          { x: 113.2, y: 47.6 },
          { x: 113.2, y: 64.3 },
        ],
        right: [
          { x: 150.4, y: 14.07 },
          { x: 150.4, y: 30.8 },
          { x: 150.4, y: 47.6 },
          { x: 150.4, y: 64.3 },
        ]
      },
      M1: {
        left: [
          { x: 113, y: 47.1 },
          { x: 113, y: 64.3 },
          { x: 150.2, y: 47.1 },
          { x: 150.2, y: 64.3 },
        ]
      },
      SK: { left: [] },
    },
    vdouble: {
      A: {
        left: [
          { x: 14.4, y: 112.9 },
          { x: 14.4, y: 163.2 },
        ],
        right: [
          { x: 51.6, y: 112.9 },
          { x: 51.6, y: 163.2 },
        ]
      },
      B: {
        left: [
          { x: 14.4, y: 112.9 },
          { x: 14.4, y: 129.7 },
          { x: 14.4, y: 146.4 },
          { x: 14.4, y: 163.2 },
        ],
        right: [
          { x: 51.6, y: 112.9 },
          { x: 51.6, y: 129.7 },
          { x: 51.6, y: 146.4 },
          { x: 51.6, y: 163.2 },
        ]
      },
      D: {
        left: [
          { x: 14.4, y: 112.9 },
          { x: 14.4, y: 129.7 },
          { x: 14.4, y: 146.4 },
          { x: 14.4, y: 163.2 },
        ],
        right: [
          { x: 51.6, y: 112.9 },
          { x: 51.6, y: 129.7 },
          { x: 51.6, y: 146.4 },
          { x: 51.6, y: 163.2 },
        ]
      },
      M1: {
        left: [
          { x: 14.25, y: 146.2 },
          { x: 14.25, y: 163.4 },
          { x: 51.4, y: 146.2 },
          { x: 51.4, y: 163.4 },
        ]
      },
      SK: { left: [] },
    },
    triple: { SK: { left: [] } },
    vtriple: { SK: { left: [] } }

  },
  tripleRightButton: {
    triple: {
      A: {
        left: [
          { x: 212.2, y: 14.07 },
          { x: 212.2, y: 64.3 },
        ],
        right: [
          { x: 249.1, y: 14.07 },
          { x: 249.1, y: 64.3 },
        ]
      },
      B: {
        left: [
          { x: 212.2, y: 14.07 },
          { x: 212.2, y: 30.8 },
          { x: 212.2, y: 47.6 },
          { x: 212.2, y: 64.3 },
        ],
        right: [
          { x: 249.1, y: 14.07 },
          { x: 249.1, y: 30.8 },
          { x: 249.1, y: 47.6 },
          { x: 249.1, y: 64.3 },
        ]
      },
      D: {
        left: [
          { x: 212.2, y: 14.07 },
          { x: 212.2, y: 30.8 },
          { x: 212.2, y: 47.6 },
          { x: 212.2, y: 64.3 },
        ],
        right: [
          { x: 249.1, y: 14.07 },
          { x: 249.1, y: 30.8 },
          { x: 249.1, y: 47.6 },
          { x: 249.1, y: 64.3 },
        ]
      },
      SK: { left: [] },
    },
    vtriple: {
      A: {
        left: [
          { x: 14.4, y: 211.6 },
          { x: 14.4, y: 261.8 },
        ],
        right: [
          { x: 51.6, y: 211.6 },
          { x: 51.6, y: 261.8 },
        ]
      },
      B: {
        left: [
          { x: 14.4, y: 211.6 },
          { x: 14.4, y: 228.3 },
          { x: 14.4, y: 245.1 },
          { x: 14.4, y: 261.8 },
        ],
        right: [
          { x: 51.6, y: 211.6 },
          { x: 51.6, y: 228.3 },
          { x: 51.6, y: 245.1 },
          { x: 51.6, y: 261.8 },
        ]
      },
      D: {
        left: [
          { x: 14.4, y: 211.6 },
          { x: 14.4, y: 228.3 },
          { x: 14.4, y: 245.1 },
          { x: 14.4, y: 261.8 },
        ],
        right: [
          { x: 51.6, y: 211.6 },
          { x: 51.6, y: 228.3 },
          { x: 51.6, y: 245.1 },
          { x: 51.6, y: 261.8 },
        ]
      },
      SK: { left: [] },
    }
  },
};
var albaPositions = {
  default: {
    icon: {
      small: {
        P1: { x: 7.7, y: 6.5 },
        P2: { x: 7.7, y: 8.3 },
        P3: { x: 7.7, y: 10.1 },
        P4: { x: 21.25, y: 6.5 },
        P5: { x: 21.25, y: 8.3 },
        P6: { x: 21.25, y: 10.1 },
        P7: { x: 14.5, y: 8.3 },
      },
      medium: {
        P1: { x: 9.42, y: 7.36 },
        P2: { x: 9.42, y: 8.3 },
        P3: { x: 9.42, y: 9.09 },
        P4: { x: 19.5, y: 7.36 },
        P5: { x: 19.5, y: 8.3 },
        P6: { x: 19.5, y: 9.09 },
        P7: { x: 14.5, y: 8.3 },
      },
      big: {
        P1: { x: 11, y: 8.3 },
        P2: { x: 11, y: 8.3 },
        P3: { x: 11, y: 8.3 },
        P4: { x: 18, y: 8.3 },
        P5: { x: 18, y: 8.3 },
        P6: { x: 18, y: 8.3 },
        P7: { x: 14.5, y: 8.3 },
      },
    },
    textL1: {
      small: {
        P1: { x: 3.2, y: 3.5 },
        P2: { x: 3.2, y: 7.46 },
        P3: { x: 3.2, y: 11.15 },
        P4: { x: 25.8, y: 3.5 },
        P5: { x: 25.8, y: 7.46 },
        P6: { x: 25.8, y: 11.15 },
        P7: { x: 14.5, y: 7.46 },
      },
      medium: {
        P1: { x: 3.2, y: 3.5 },
        P2: { x: 3.2, y: 6.95 },
        P3: { x: 3.2, y: 10.38 },
        P4: { x: 25.8, y: 3.5 },
        P5: { x: 25.8, y: 6.95 },
        P6: { x: 25.8, y: 10.38 },
        P7: { x: 14.5, y: 6.95 },
      },
      big: {
        P1: { x: 3.2, y: 3.5 },
        P2: { x: 3.2, y: 6.65 },
        P3: { x: 3.2, y: 9.84 },
        P4: { x: 25.8, y: 3.5 },
        P5: { x: 25.8, y: 6.65 },
        P6: { x: 25.8, y: 9.84 },
        P7: { x: 14.5, y: 6.65 },
      },
    },
    textL2: {
      small: {
        P1: { x: 3.2, y: 3.5 },
        P2: { x: 3.2, y: 6.28 },
        P3: { x: 3.2, y: 8.7 },
        P4: { x: 25.8, y: 3.5 },
        P5: { x: 25.8, y: 6.28 },
        P6: { x: 25.8, y: 8.7 },
        P7: { x: 14.5, y: 6.28 },
      },
      medium: {
        P1: { x: 3.2, y: 3.5 },
        P2: { x: 3.2, y: 5.7 },
        P3: { x: 3.2, y: 7.35 },
        P4: { x: 25.8, y: 3.5 },
        P5: { x: 25.8, y: 5.7 },
        P6: { x: 25.8, y: 7.35 },
        P7: { x: 14.5, y: 5.4 },
      },
      big: {
        P1: { x: 3.2, y: 3.5 },
        P2: { x: 3.2, y: 5.1 },
        P3: { x: 3.2, y: 5.95 },
        P4: { x: 25.8, y: 3.5 },
        P5: { x: 25.8, y: 5.1 },
        P6: { x: 25.8, y: 5.95 },
        P7: { x: 14.5, y: 5.1 },
      },
    },
  },
  metal: {
    icon: {
      medium: {
        P1: { x: 7.62, y: 7.36 },
        P2: { x: 7.62, y: 8.273 },
        P3: { x: 7.62, y: 9.09 },
        P4: { x: 21.3, y: 7.36 },
        P5: { x: 21.3, y: 8.273 },
        P6: { x: 21.3, y: 9.09 },
        P7: { x: 14.5, y: 8.273 },
      },
    },
    textL1: {
      medium: {
        P1: { x: 3.2, y: 3.5 },
        P2: { x: 3.2, y: 7 },
        P3: { x: 3.2, y: 9.86 },
        P4: { x: 25.8, y: 3.5 },
        P5: { x: 25.8, y: 7 },
        P6: { x: 25.8, y: 9.86 },
        P7: { x: 14.5, y: 9.86 },
      },
    },
    textL2: { //this is actualy T1 text (or top text) and for T2 (bottom text) we add L2offset
      medium: {
        P1: { x: 3.2, y: 3.5 },
        P2: { x: 3.2, y: 5.21 },
        P3: { x: 3.2, y: 6.32 },
        P4: { x: 25.8, y: 3.5 },
        P5: { x: 25.8, y: 5.21 },
        P6: { x: 25.8, y: 6.32 },
        P7: { x: 14.5, y: 5.21 },
      },
    }
  },
  buttonSize: { height: 11, width: 24 },
  L2offset: {
    default: {
      small: 2.45,
      medium: 3.15,
      big: 3.85,
    },
    metal: {
      medium: 3.54,
    }
  },
  alignment: {
    iconOnly: {
      topleft: { textL1: "", icon: "P2" },
      topcenter: { textL1: "", icon: "P7" },
      topright: { textL1: "", icon: "P5" },
      bottomleft: { textL1: "", icon: "P2" },
      bottomcenter: { textL1: "", icon: "P7" },
      bottomright: { textL1: "", icon: "P5" },
    },
    singleLineText: {
      topleft: { textL1: "P2", icon: "" },
      topcenter: { textL1: "P7", icon: "" },
      topright: { textL1: "P5", icon: "" },
      bottomleft: { textL1: "P2", icon: "" },
      bottomcenter: { textL1: "P7", icon: "" },
      bottomright: { textL1: "P5", icon: "" },
    },
    iconSingleLineText: {
      topleft: { textL1: "P1", icon: "P6" },
      topright: { textL1: "P4", icon: "P3" },
      bottomleft: { textL1: "P3", icon: "P4" },
      bottomright: { textL1: "P6", icon: "P1" },
    },
    doubleLineText: {
      topleft: { textL1: "P2", icon: "" },
      topcenter: { textL1: "P7", icon: "" },
      topright: { textL1: "P5", icon: "" },
      bottomleft: { textL1: "P2", icon: "" },
      bottomcenter: { textL1: "P7", icon: "" },
      bottomright: { textL1: "P5", icon: "" },
    },
    iconDoubleLineText: {
      topleft: { textL1: "P1", icon: "P6" },
      topright: { textL1: "P4", icon: "P3" },
      bottomleft: { textL1: "P3", icon: "P4" },
      bottomright: { textL1: "P6", icon: "P1" },
    },
  },
};

import isBigIconMixin from "../../../mixins/isBigIconMixin";
import PanelImage from "./PanelImage.vue";

export default {
  name: "AlbaPanel",
  components: {
    EngravingElements,
    PanelImage
  },
  mixins: [isBigIconMixin],
  data() {
    return {
      engravingElementsVisible: false,
      xIconMoveOffset: {
        single: 2.4,
        double: 3.6,
        vdouble: 2.4,
        triple: 2.4,
        vtriple: 2.4
      }

    };
  },
  methods: {
    getAlignment(i, alignment = "alignment") {
      if (!this.isBigIcon(i.content)) {
        return this.$store.state.artwork[alignment];
      }
      return this.$store.state.artwork[alignment]
        .replace("left", "center")
        .replace("right", "center");
    },
  },
  created() {
    this.styleMap = this.$store.state.styleMap;
  },
  computed: {
    layer4: function () {
      var textSizeLabel =
        this.$store.state.textSizeMap[this.$store.state.artwork.fontSize];
      var alignment = {};
      if (
        typeof albaPositions.alignment[this.$store.state.artwork.layoutStyle] !=
        "undefined"
      ) {
        alignment =
          albaPositions.alignment[this.$store.state.artwork.layoutStyle][
          this.$store.state.artwork.alignment
          ];
      }

      var layoutList = [];

      let right = [];

      let left = albaButtonPositionsCombinations.leftButton[this.$store.state.artwork.format][this.$store.state.artwork.leftSideLeftButton].left
      if (this.$store.state.artwork.leftSideRightButton !== null) {
        right = albaButtonPositionsCombinations.leftButton[this.$store.state.artwork.format][this.$store.state.artwork.leftSideRightButton].right
      }

      let albaButtonPositions = left.concat(right);

      for (
        var i = 0;
        i <
        albaButtonPositions.length;
        i++
      ) {
        var lm = albaButtonPositions[i];

        var iconSizeLabel =
          this.$store.state.iconSizeMap[
          (this.isBigIcon(this.$store.state.artwork.content[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.iconSize
          ];


        var o = {
          id: i,
          top: lm.y + 2,
          left: lm.x + this.xIconMoveOffset[this.$store.state.artwork.format],
          height:
            albaPositions.buttonSize.height,
          width:
            albaPositions.buttonSize.width,
          fontSize:
            this.$store.state.fontSizeMap[this.$store.getters.metalOrDefault][this.$store.state.artwork.fontSize],
          iconSize: (this.isBigIcon(this.$store.state.artwork.content[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.iconSize,
          iconSizeLabel: iconSizeLabel,
          alignment: alignment,
          iconCords: (this.isBigIcon(this.$store.state.artwork.content[i])
            ? albaPositions[this.$store.getters.metalOrDefault].icon[iconSizeLabel]["P7"]
            : albaPositions[this.$store.getters.metalOrDefault].icon[iconSizeLabel][alignment.icon]) || {
            x: 0,
            y: 0,
          },
          textCords: (this.$store.state.artwork.content[i].hasTextL2
            ? albaPositions[this.$store.getters.metalOrDefault].textL2[textSizeLabel][alignment.textL1]
            : albaPositions[this.$store.getters.metalOrDefault].textL1[textSizeLabel][alignment.textL1]) || {
            x: 0,
            y: 0,
          },
          textL2Offset: albaPositions.L2offset[this.$store.getters.metalOrDefault][textSizeLabel] || 0,
          style: {
            alignment: "middle",
            constrain: this.styleMap[this.$store.state.artwork.type][
              this.$store.state.artwork.layout
            ][this.$store.state.artwork.layoutStyle][i]
          },
          content: this.$store.state.artwork.content[i],
        };
        layoutList.push(o);
        this.$store.commit("setAlignment", {
          alignment: this.getAlignment(o),
          index: i,
        });
      }
      
      return layoutList;
    },
    rightLayer4: function () {
      var textSizeLabel =
        this.$store.state.textSizeMap[this.$store.state.artwork.rightFontSize];
      var alignment = {};
      if (
        typeof albaPositions.alignment[
        this.$store.state.artwork.rightLayoutStyle
        ] != "undefined"
      ) {
        alignment =
          albaPositions.alignment[this.$store.state.artwork.rightLayoutStyle][
          this.$store.state.artwork.rightAlignment
          ];
      }
      var layoutList = [];

      let right = [];

      let left = albaButtonPositionsCombinations.rightButton[this.$store.state.artwork.format][this.$store.state.artwork.rightSideLeftButton].left
      if (this.$store.state.artwork.rightSideRightButton !== null) {
        right = albaButtonPositionsCombinations.rightButton[this.$store.state.artwork.format][this.$store.state.artwork.rightSideRightButton].right
      }

      let albaButtonPositions = left.concat(right);

      for (
        var i = 0;
        i <
        albaButtonPositions.length;
        i++
      ) {
        var lm = albaButtonPositions[i];
        var iconSizeLabel =
          this.$store.state.iconSizeMap[
          (this.isBigIcon(this.$store.state.artwork.rightContent[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.rightIconSize
          ];

        

        var o = {
          id: i,
          top: lm.y + 2,
          left: lm.x + this.xIconMoveOffset[this.$store.state.artwork.format],
          height:
            albaPositions.buttonSize.height,
          width:
            albaPositions.buttonSize.width,
          fontSize:
            this.$store.state.fontSizeMap[this.$store.getters.metalOrDefault][
            this.$store.state.artwork.rightFontSize
            ],
          iconSize: (this.isBigIcon(this.$store.state.artwork.rightContent[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.rightIconSize,
          iconSizeLabel: iconSizeLabel,
          alignment: alignment,
          iconCords: (this.isBigIcon(this.$store.state.artwork.rightContent[i])
            ? albaPositions[this.$store.getters.metalOrDefault].icon[iconSizeLabel]["P7"]
            : albaPositions[this.$store.getters.metalOrDefault].icon[iconSizeLabel][alignment.icon]) || {
            x: 0,
            y: 0,
          },
          textCords: (this.$store.state.artwork.rightContent[i].hasTextL2
            ? albaPositions[this.$store.getters.metalOrDefault].textL2[textSizeLabel][alignment.textL1]
            : albaPositions[this.$store.getters.metalOrDefault].textL1[textSizeLabel][alignment.textL1]) || {
            x: 0,
            y: 0,
          },
          textL2Offset: albaPositions.L2offset[this.$store.getters.metalOrDefault][textSizeLabel] || 0,
          style: {
            alignment: "middle",
            constrain:
              this.styleMap[this.$store.state.artwork.type][
              this.$store.state.artwork.rightLayout
              ][this.$store.state.artwork.rightLayoutStyle][i],
          },
          content: this.$store.state.artwork.rightContent[i],
        };

        layoutList.push(o);
        this.$store.commit("setRightAlignment", {
          alignment: this.getAlignment(o, "rightAlignment"),
          index: i,
        });
      }
      return layoutList;
    },
    tripleRightLayer4: function () {

      var textSizeLabel =
        this.$store.state.textSizeMap[
        this.$store.state.artwork.tripleRightFontSize
        ];
      var alignment = {};
      if (
        typeof albaPositions.alignment[
        this.$store.state.artwork.tripleRightLayoutStyle
        ] != "undefined"
      ) {
        alignment =
          albaPositions.alignment[
          this.$store.state.artwork.tripleRightLayoutStyle
          ][this.$store.state.artwork.tripleRightAlignment];
      }
      var layoutList = [];

      let right = [];

      let left = albaButtonPositionsCombinations.tripleRightButton[this.$store.state.artwork.format][this.$store.state.artwork.tripleRightSideLeftButton].left

      if (this.$store.state.artwork.tripleRightSideRightButton !== null) {
        right = albaButtonPositionsCombinations.tripleRightButton[this.$store.state.artwork.format][this.$store.state.artwork.tripleRightSideRightButton].right
      }

      let albaButtonPositions = left.concat(right);

      for (
        var i = 0;
        i <
        albaButtonPositions.length;
        i++
      ) {
        var lm = albaButtonPositions[i];

        var iconSizeLabel =
          this.$store.state.iconSizeMap[
          (this.isBigIcon(this.$store.state.artwork.tripleRightContent[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.tripleRightIconSize
          ];

        var o = {
          id: i,
          top: lm.y + 2,
          left: lm.x + this.xIconMoveOffset[this.$store.state.artwork.format],
          height:
            albaPositions.buttonSize.height,
          width:
            albaPositions.buttonSize.width,
          fontSize:
            this.$store.state.fontSizeMap[this.$store.getters.metalOrDefault][
            this.$store.state.artwork.tripleRightFontSize
            ],
          iconSize: (this.isBigIcon(this.$store.state.artwork.tripleRightIconSize[i]) && !this.$store.getters.isFullMetal)
            ? this.$store.state.bigIconSize
            : this.$store.state.artwork.tripleRightIconSize,
          iconSizeLabel: iconSizeLabel,
          alignment: alignment,
          iconCords: (this.isBigIcon(
            this.$store.state.artwork.tripleRightContent[i]
          )
            ? albaPositions[this.$store.getters.metalOrDefault].icon[iconSizeLabel]["P7"]
            : albaPositions[this.$store.getters.metalOrDefault].icon[iconSizeLabel][alignment.icon]) || {
            x: 0,
            y: 0,
          },
          textCords: (this.$store.state.artwork.tripleRightContent[i]?.hasTextL2
            ? albaPositions[this.$store.getters.metalOrDefault].textL2[textSizeLabel][alignment.textL1]
            : albaPositions[this.$store.getters.metalOrDefault].textL1[textSizeLabel][alignment.textL1]) || {
            x: 0,
            y: 0,
          },
          textL2Offset: albaPositions.L2offset[this.$store.getters.metalOrDefault][textSizeLabel] || 0,
          style: {
            alignment: "middle",
            constrain:
              this.styleMap[this.$store.state.artwork.type][
              this.$store.state.artwork.tripleRightLayout
              ][this.$store.state.artwork.tripleRightLayoutStyle][i],
          },
          content: this.$store.state.artwork.tripleRightContent[i],
        };

        layoutList.push(o);
        this.$store.commit("setTripleRightAlignment", {
          alignment: this.getAlignment(o, "tripleRightAlignment"),
          index: i,
        });
      }
      return layoutList;
    },
  },
};
</script>
